import axios from 'axios';
import qs from 'querystring';
import store from '@/store'

const baseURL = process.env.VUE_APP_ENGINE_URL;

const apiUsername = process.env.VUE_APP_ENGINE_API_USER;
const apiPassword = process.env.VUE_APP_ENGINE_API_PASS;
const apiToken = Buffer.from(`${apiUsername}:${apiPassword}`, 'utf8').toString('base64');

const state = {
  msAuthToken: '',
  msGroupId: '',
  msParentFolderId: '',
  msUploadFolderId: '',
  fileBuffer: '',
  fileBufferError: '',
  uploadedFileData: [],
  uploadSuccessful: false,
  uploadError: '',
  fileDataSaved: false,
  imageDataSaved: false,
  taskFiles: [],
  caseFiles: [],
  allFiles: [],
  deletedFile: '',
  downloadFileName: '',
  downloadFileUrl: '',
  gulperUrl: '',
  gulperFileHeaders: [],
  gulperFilePreview: [],
  gulped: false
};

const getters = {
  uploadError: (state) => state.uploadError,
  taskFiles: (state) => state.taskFiles,
  caseFiles: (state) => state.caseFiles,
  allFiles: (state) => state.allFiles,
  downloadFileName: (state) => state.downloadFileName,
  downloadFileUrl: (state) => state.downloadFileUrl,
  imageDataSaved: (state) => state.imageDataSaved,
  gulperUrl: (state) => state.gulperUrl,
  gulperFileHeaders: (state) => state.gulperFileHeaders,
  gulperFilePreview: (state) => state.gulperFilePreview,
  gulped: (state) => state.gulped
};

const actions = {
  fileBuffer({ commit }, file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onloadend = function(e) {
        commit('FILE_BUFFER', e.target.result);
        resolve(e.target.result);
      }
      reader.onerror = function (e) {
        commit('FILE_BUFFER_ERROR', e.target.error);
        reject(e.target.error);
      }
      reader.readAsArrayBuffer(file);

    });
  },
  async getMSAuth({state, rootState, commit}) {
    await this.dispatch('getStorageDetails').then( () => {
      let payload = qs['stringify']({
        grant_type: 'client_credentials',
        scope: 'https://graph.microsoft.com/.default',
        client_id: rootState.admin.storageDetails.officeClientId,
        client_secret: rootState.admin.storageDetails.officeClientSecret
      });
      
      let data = {
        'variables': {
          'storage': { 'value': 'onedrive', 'type': 'String' },
          'url': { 'value': 'https://login.microsoftonline.com/' + rootState.admin.storageDetails.officeTenantId + '/oauth2/v2.0/token', 'type': 'String' },
          'payload': { 'value': payload, 'type': 'String' }
        },
        'withVariablesInReturn': true
      }
      return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
        let response = JSON.parse(result.data.variables.response.value);
        
        if(response.error == 'invalid_client') {
          let msg = response.error_description;
          commit('ERROR_MESSAGE', msg);
        }else {
          state.msAuthToken = response.access_token;
          commit('MS_AUTH_TOKEN', response.access_token);
        }
      }).catch(error => {
        throw new Error(`API ${error}`);
      });
    });
  },
  uploadFilesToMS({state, rootState, commit}, files) {
    const PromiseArr = [];
    // Replace group name with customer info
    let groupName = rootState.admin.storageDetails.officeGroupName;
    // Find the ID of the specified group
    PromiseArr.push(
      axios.get('https://graph.microsoft.com/v1.0/groups?$search="displayName:' + groupName + '"', {headers: {'ConsistencyLevel': 'eventual', 'Authorization': 'Bearer ' + state.msAuthToken}}).then( result => new Promise(resolve => {
        state.msGroupId = result.data.value[0].id;
        commit('MS_GROUP_ID', result.data.value[0].id);
        // Check if upload folder exists
        let path = rootState.admin.storageDetails.officeUploadPath;
        axios.get('https://graph.microsoft.com/v1.0/groups/' + result.data.value[0].id + '/drive/root:/' + path + ':/children', {headers: {'Authorization': 'Bearer ' + state.msAuthToken}}).then( res => {

          let folderExists = false;
          for(let i = 0; i < res.data.value.length; i++) {
            let folderName = 'Case ' + this.getters['caseId'];
            if(res.data.value[i].name == folderName) {
              folderExists = true;
              state.msUploadFolderId = res.data.value[i].id;
              commit('MS_UPLOAD_FOLDER_ID', res.data.value[i].id);
              break;
            }
          }

          // If not, create it
          if(!folderExists) {
            // Get parent folder ID
            axios.get('https://graph.microsoft.com/v1.0/groups/' + result.data.value[0].id + '/drive/root:/' + path, {headers: {'Authorization': 'Bearer ' + state.msAuthToken}}).then( res => {
              state.msParentFolderId = res.data.id;
              commit('MS_PARENT_FOLDER_ID', result.data.id);

              // Create new folder
              let folderName = 'Case ' + this.getters['caseId'];
              let newFolder = {
                'name': folderName,
                'folder': { },
                '@microsoft.graph.conflictBehavior': 'rename'
              };

              axios.post('https://graph.microsoft.com/v1.0/groups/' + result.data.value[0].id + '/drive/items/' + res.data.id + '/children', newFolder, {headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + state.msAuthToken}}).then( resp => {
                state.msUploadFolderId = resp.data.id;
                commit('MS_UPLOAD_FOLDER_ID', resp.data.id);

                resolve();
              }).catch(error => {
                throw new Error(`API ${error}`);
              });
            }).catch(error => {
              throw new Error(`API ${error}`);
            });
            
          }else {
            resolve();
          }
        }).catch(error => {
          throw new Error(`API ${error}`);
        });
      }).catch(error => {
        throw new Error(`API ${error}`);
      })));
      
    Promise.all(PromiseArr).then( () => {

      try {
        for(let i = 0; i < files.length; i++) {
          // Get file buffer
          this.dispatch('fileBuffer', files[i]).then( arrayBuffer => {

            // Upload file
            let payload = {
              'file': files[i],
              'arrayBuffer': arrayBuffer
            };
            this.dispatch('uploadFile', payload);

          });
        }
      } catch(e) {
        commit('UPLOAD_ERROR', e);
      }
    });
  },
  uploadFile({state, commit}, payload) {
    let file = payload.file;
    let arrayBuffer = payload.arrayBuffer;
    // Large file upload
    let msUploadSessionUrl = 'https://graph.microsoft.com/v1.0/groups/' + state.msGroupId + '/drive/items/' + state.msUploadFolderId + ':/' + file.name + ':/createUploadSession';
    let sessionBody = {
      'item': {
        '@microsoft.graph.conflictBehavior': 'rename',
        'name': file.name
      }
    };
    axios.post(msUploadSessionUrl, sessionBody, {headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + state.msAuthToken}}).then( session => {
      let msUploadUrl = session.data.uploadUrl;

      axios.put(msUploadUrl, arrayBuffer, {headers: {'Content-Range': 'bytes 0-' + parseInt(file.size - 1) + '/' + file.size}}).then( result => {
        let fileData = {
          'storageType': 'office',
          'id': result.data.id,
          'name': result.data.name,
          'size': file.size,
          'webUrl': result.data.webUrl,
          'created': new Date()
        }
        this.dispatch('uploadFileData', fileData);
        commit('UPLOAD_SUCCESSFUL', true);
      }).catch(error => {
        throw new Error(`API ${error}`);
      });
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  uploadFileData({state, commit}, payload) {
    // Format date
    let cdate = new Date(payload.created);
    let createdDateTime = new Intl.DateTimeFormat('en-GB', 
      {
        day: 'numeric',
        month: 'numeric', 
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      }).format(cdate);

    let data = {
      'variables': {
        'storage': { 'value': 'data', 'type': 'String' },
        'requestType': { 'value': 'save', 'type': 'String' },
        'caseId': { 'value': this.getters['instanceId'], 'type': 'String' },
        'taskId': { 'value': this.getters['taskId'], 'type': 'String' },
        'taskName': { 'value': this.getters['taskName'], 'type': 'String' },
        'processName': { 'value': this.getters['processName'], 'type': 'String' },
        'filename': { 'value': payload.name, 'type': 'String' },
        'filesize': { 'value': payload.size, 'type': 'String' },
        'url': { 'value': payload.webUrl, 'type': 'String' },
        'created': { 'value': createdDateTime, 'type': 'String' },
        'itemId': { 'value': payload.id, 'type': 'String' },
        'uploadedBy': { 'value': store.state.currentUser, 'type': 'String' }
      }
    };

    if(payload.storageType == 'local') {
      data.variables['storageType'] = { 'value': 'local', 'type': 'String' };
      data.variables['mimeType'] = { 'value': payload.mimeType, 'type': 'String' };
      data.variables['fileData'] = { 'value': payload.fileData, 'type': 'File', 'valueInfo': { 'filename': payload.name, 'mimetype': payload.mimeType, 'encoding': 'UTF-8' } };
    }else {
      data.variables['storageType'] = { 'value': 'office', 'type': 'String' };
      data.variables['msGroupId'] = { 'value': state.msGroupId, 'type': 'String' };
    }
    
    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      // Force a 1 second wait for local storage
      setTimeout(function(){
        commit('FILE_DATA_SAVED', true);
      }, 1000);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  uploadExternalFileData({state, commit}, payload) {
    // Format date
    let cdate = new Date(payload.created);
    let createdDateTime = new Intl.DateTimeFormat('en-GB', 
      {
        day: 'numeric',
        month: 'numeric', 
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      }).format(cdate);

    let data = {
      'variables': {
        'storage': { 'value': 'data', 'type': 'String' },
        'requestType': { 'value': 'save', 'type': 'String' },
        'caseId': { 'value': this.getters['origInstanceId'], 'type': 'String' },
        'taskId': { 'value': this.getters['taskId'], 'type': 'String' },
        'taskName': { 'value': this.getters['taskName'], 'type': 'String' },
        'processName': { 'value': this.getters['processName'], 'type': 'String' },
        'filename': { 'value': payload.name, 'type': 'String' },
        'filesize': { 'value': payload.size, 'type': 'String' },
        'url': { 'value': payload.webUrl, 'type': 'String' },
        'created': { 'value': createdDateTime, 'type': 'String' },
        'itemId': { 'value': payload.id, 'type': 'String' },
        'uploadedBy': { 'value': 'External User', 'type': 'String' }
      }
    };

    if(payload.storageType == 'local') {
      data.variables['storageType'] = { 'value': 'local', 'type': 'String' };
      data.variables['mimeType'] = { 'value': payload.mimeType, 'type': 'String' };
      data.variables['fileData'] = { 'value': payload.fileData, 'type': 'File', 'valueInfo': { 'filename': payload.name, 'mimetype': payload.mimeType, 'encoding': 'UTF-8' } };
    }else {
      data.variables['storageType'] = { 'value': 'office', 'type': 'String' };
      data.variables['msGroupId'] = { 'value': state.msGroupId, 'type': 'String' };
    }
    
    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( () => {      
      // Force a 1 second wait for local storage
      setTimeout(function(){
        commit('FILE_DATA_SAVED', true);
      }, 1000);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  uploadImageData({commit, state}, payload) {
    state.imageDataSaved = false;
    // Format date
    let cdate = new Date(payload.created);
    let createdDateTime = new Intl.DateTimeFormat('en-GB', 
      {
        day: 'numeric',
        month: 'numeric', 
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      }).format(cdate);

    let data = {
      'variables': {
        'storage': { 'value': 'data', 'type': 'String' },
        'requestType': { 'value': 'saveImg', 'type': 'String' },
        'caseId': { 'value': '', 'type': 'String' },
        'taskId': { 'value': '', 'type': 'String' },
        'taskName': { 'value': '', 'type': 'String' },
        'processName': { 'value': '', 'type': 'String' },
        'filename': { 'value': payload.name, 'type': 'String' },
        'filesize': { 'value': payload.size, 'type': 'String' },
        'url': { 'value': '', 'type': 'String' },
        'created': { 'value': createdDateTime, 'type': 'String' },
        'itemId': { 'value': payload.id, 'type': 'String' },
        'uploadedBy': { 'value': store.state.currentUser, 'type': 'String' },
        'mimeType': { 'value': payload.mimeType, 'type': 'String' },
        'fileData': { 'value': payload.fileData, 'type': 'File', 'valueInfo': { 'filename': payload.name, 'mimetype': payload.mimeType, 'encoding': 'UTF-8' } }
      }
    };
    
    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => {      
      if(res.status == 200) {
        commit('IMAGE_DATA_SAVED', true);
        return true;
      }else {
        commit('IMAGE_DATA_SAVED', false);
        return false;
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  uploadGulperData({commit}, payload) {
    let data = {
      'variables': {
        'storage': { 'value': 'gulper', 'type': 'String' },
        'requestType': { 'value': payload.requestType, 'type': 'String' },
        'headerRow': { 'value': payload.headerRow, 'type': 'Integer' },
        'filename': { 'value': payload.name, 'type': 'String' },
        'fileData': { 'value': payload.fileData, 'type': 'File', 'valueInfo': { 'filename': payload.name, 'mimetype': payload.mimeType, 'encoding': 'UTF-8' } }
      },
      'withVariablesInReturn': true
    };

    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      commit('GULPER_URL', result.data.variables.gulperUrl.value);
      commit('GULPER_FILE_HEADERS', JSON.parse(result.data.variables.fileHeaders.value));
      commit('GULPER_FILE_PREVIEW', JSON.parse(result.data.variables.filePreview.value));
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  importGulperData({commit}, payload) {
    let data = {
      'variables': {
        'storage': { 'value': 'gulper', 'type': 'String' },
        'requestType': { 'value': payload.requestType, 'type': 'String' },
        'headerRow': { 'value': payload.headerRow, 'type': 'Integer' },
        'targetTable': { 'value': payload.targetTable, 'type': 'String' },
        'gulperUrl': { 'value': payload.url, 'type': 'String' },
        'columns': { 'value': payload.columns, 'type': 'Json' }
      },
      'withVariablesInReturn': true
    };

    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      commit('GULPED', result.data.variables.gulped.value);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getTaskFiles({commit}) {
    let data = {
      'variables': {
        'storage': { 'value': 'data', 'type': 'String' },
        'requestType': { 'value': 'get', 'type': 'String' },
        'caseId': { 'value': this.getters['instanceId'], 'type': 'String' },
        'taskId': { 'value': this.getters['taskId'], 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      commit('TASK_FILES', JSON.parse(result.data.variables.fileData.value));
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getCaseFiles({commit}) {
    let data = {
      'variables': {
        'storage': { 'value': 'data', 'type': 'String' },
        'requestType': { 'value': 'getCase', 'type': 'String' },
        'caseId': { 'value': this.getters['instanceId'], 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      commit('CASE_FILES', JSON.parse(result.data.variables.fileData.value));
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getExternalCaseFiles({commit}) {
    let data = {
      'variables': {
        'storage': { 'value': 'data', 'type': 'String' },
        'requestType': { 'value': 'getCase', 'type': 'String' },
        'caseId': { 'value': this.getters['origInstanceId'], 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {      
      commit('CASE_FILES', JSON.parse(result.data.variables.fileData.value));
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getAllFiles({commit}, role) {
    let data = {
      'variables': {
        'storage': { 'value': 'data', 'type': 'String' },
        'requestType': { 'value': 'getAll', 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    
    if(role == 'adminRole') {
      data.variables['filter'] = { 'value': '', 'type': 'String' };
    }else {
      data.variables['filter'] = { 'value': store.state.currentUser, 'type': 'String' };
    }
    
    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      commit('ALL_FILES', JSON.parse(result.data.variables.fileData.value));
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  downloadFile({commit}, itemId) {
    let data = {
      'variables': {
        'storage': { 'value': 'retrieve', 'type': 'String' },
        'itemId': { 'value': itemId, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let fileName = result.data.variables.fileName.value;
      let mimeType = result.data.variables.mimeType.value;
      let fileData = result.data.variables.fileBuffer.value;

      const byteCharacters = atob(fileData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let blob = new Blob([byteArray], {type: mimeType});
      let url = window.URL.createObjectURL(blob);

      commit('DOWNLOAD_FILE_NAME', fileName);
      commit('DOWNLOAD_FILE_URL', url);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  downloadExternalFile({commit}, itemId) {
    let data = {
      'variables': {
        'storage': { 'value': 'retrieve', 'type': 'String' },
        'itemId': { 'value': itemId, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {      
      let fileName = result.data.variables.fileName.value;
      let mimeType = result.data.variables.mimeType.value;
      let fileData = result.data.variables.fileBuffer.value;

      const byteCharacters = atob(fileData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let blob = new Blob([byteArray], {type: mimeType});
      let url = window.URL.createObjectURL(blob);

      commit('DOWNLOAD_FILE_NAME', fileName);
      commit('DOWNLOAD_FILE_URL', url);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteFile({state, commit}, payload) {
    axios.delete('https://graph.microsoft.com/v1.0/groups/' + payload.groupId + '/drive/items/' + payload.fileId, {headers: {'Authorization': 'Bearer ' + state.msAuthToken}}).then( result => {      
      if(result.status == 204) {
        
        let data = {
          'variables': {
            'storage': { 'value': 'data', 'type': 'String' },
            'requestType': { 'value': 'delete', 'type': 'String' },
            'itemId': { 'value': payload.fileId, 'type': 'String' }
          }
        };
        
        axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
          commit('DELETED_FILE', payload.fileId);
        }).catch(error => {
          throw new Error(`API ${error}`);
        });
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteExternalFile({state, commit}, payload) {
    axios.delete('https://graph.microsoft.com/v1.0/groups/' + payload.groupId + '/drive/items/' + payload.fileId, {headers: {'Authorization': 'Bearer ' + state.msAuthToken}}).then( result => {      
      if(result.status == 204) {
        
        let data = {
          'variables': {
            'storage': { 'value': 'data', 'type': 'String' },
            'requestType': { 'value': 'delete', 'type': 'String' },
            'itemId': { 'value': payload.fileId, 'type': 'String' }
          }
        };
        
        axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( () => {      
          commit('DELETED_FILE', payload.fileId);
        }).catch(error => {
          throw new Error(`API ${error}`);
        });
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteLocalFile({commit}, itemId) {
    let data = {
      'variables': {
        'storage': { 'value': 'data', 'type': 'String' },
        'requestType': { 'value': 'delete', 'type': 'String' },
        'itemId': { 'value': itemId, 'type': 'String' }
      }
    };
    
    axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('DELETED_FILE', itemId);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteExternalLocalFile({commit}, itemId) {
    let data = {
      'variables': {
        'storage': { 'value': 'data', 'type': 'String' },
        'requestType': { 'value': 'delete', 'type': 'String' },
        'itemId': { 'value': itemId, 'type': 'String' }
      }
    };
    
    axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( () => {      
      commit('DELETED_FILE', itemId);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  }
};

const mutations = {
  MS_AUTH_TOKEN(state, payload) {
    state.msAuthToken = payload;
  },
  MS_GROUP_ID(state, payload) {
    state.msGroupId = payload;
  },
  MS_PARENT_FOLDER_ID(state, payload) {
    state.msParentFolderId = payload;
  },
  MS_UPLOAD_FOLDER_ID(state, payload) {
    state.msUploadFolderId = payload;
  },
  FILE_BUFFER(state, payload) {
    state.fileBuffer = payload;
  },
  FILE_BUFFER_ERROR(state, payload) {
    state.fileBufferError = payload;
  },
  UPLOADED_FILE_DATA(state, payload) {
    state.uploadedFileData = payload;
  },
  UPLOAD_SUCCESSFUL(state, payload) {
    state.uploadSuccessful = payload;
  },
  UPLOAD_ERROR(state, payload) {
    state.uploadError = payload;
  },
  FILE_DATA_SAVED(state, payload) {
    state.fileDataSaved = payload;
  },
  IMAGE_DATA_SAVED(state, payload) {
    state.imageDataSaved = payload;
  },
  TASK_FILES(state, payload) {
    state.taskFiles = payload;
  },
  CASE_FILES(state, payload) {
    state.caseFiles = payload;
  },
  ALL_FILES(state, payload) {
    state.allFiles = payload;
  },
  DOWNLOAD_FILE_NAME(state, payload) {
    state.downloadFileName = payload;
  },
  DOWNLOAD_FILE_URL(state, payload) {
    state.downloadFileUrl = payload;
  },
  DELETED_FILE(state, payload) {
    state.deletedFile = payload;
  },
  GULPER_URL(state, payload) {
    state.gulperUrl = payload;
  },
  GULPER_FILE_HEADERS(state, payload) {
    state.gulperFileHeaders = payload;
  },
  GULPER_FILE_PREVIEW(state, payload) {
    state.gulperFilePreview = payload;
  },
  GULPED(state, payload) {
    state.gulped = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}